import is from "is_js";
import lzbase62 from "lzbase62";

export function countUp(value) {
  // Initial variables
  let secondsDuration
  if (is.date(value)) {
    secondsDuration = (new Date() - value) / 1000;
  } else {
    secondsDuration = value / 1000
  }
  const seconds = Math.floor(secondsDuration % 60);
  const minutes = Math.floor(secondsDuration / 60 % 60);
  const hours = Math.floor(secondsDuration / 60 / 60 % 24);
  const days = Math.floor(secondsDuration / 60 / 60 / 24);
  let timeString = `${_.padStart(minutes, 2, "0")}:${_.padStart(seconds, 2, "0")}`;

  if (is.above(hours, 0)) {
    timeString = `${_.padStart(hours, 2, "0")}:${timeString}`;
  }

  if (is.above(days, 0)) {
    timeString = `${_.padStart(days, 2, "0")}:${timeString}`;
  }

  // Return time string
  return timeString;
}



// WEBPACK FOOTER //
// ./src/utils/board.js